export default "__VITE_ASSET__w7I7jO8w__"